<template>
    <div class="toolbar-impostazioni">
        <v-btn color="primary" icon small :loading="refreshing" @click="$emit('refresh')"
            v-tooltip.bottom="'Ricarica i dati e ripristina saldo e data salvati'">
            <v-icon>refresh</v-icon>
        </v-btn>

        <v-text-field class="campo-data" :value="startingBalance" @input="updateBalance" label="Saldo Iniziale Banca"
            prefix="€" type="number" outlined dense hide-details />

        <v-text-field class="campo-data" :value="startingDate" @input="updateDate" label="Data Inizio Calcolo"
            type="date" outlined dense hide-details />

        <v-btn color="primary" small :disabled="!modified" :loading="saving" @click="$emit('salvaImpostazioni')"
            v-tooltip.bottom="'Salva saldo e data inizio calcolo come valori predefiniti per tutti gli utenti'">
            <v-icon left small>save</v-icon>
            Salva
        </v-btn>

        <div class="gruppo-storico">
            <v-checkbox class="check-storico" label="Mostra storico" color="primary" hide-details :input-value="history"
                @change="updateHistory" />
            <v-text-field v-if="history" class="campo-data" :value="historyDate" label="Data inizio storico" type="date"
                :max="startingDate" outlined dense hide-details @input="updateHistoryDate" />
        </div>

        <div class="azioni-destra">
            <div class="text-caption messaggio" :class="messageClass" :title="message">
                {{ message }}
            </div>
            <v-btn icon small color="primary" :loading="refreshing" @click="$emit('importaDati')"
                v-tooltip.bottom="'Importa dati'">
                <v-icon>cloud_sync</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>

export default {
    name: "CashflowSettings",

    props: {
        startingBalance: { type: Number, required: true },
        startingDate: { type: String, required: true, default: null },
        message: { type: String, default: '' },
        historyDate: { type: String, default: null },
        history: { type: Boolean, default: false },
        // true se saldo o data inizio sono stati cambiati e non ancora salvati nel database
        modified: { type: Boolean, default: false },
        saving: { type: Boolean, default: false },
    },

    data: () => ({
        menuDate: false,
        refreshing: false,
    }),

    computed: {
        messageClass() {
            return this.message.startsWith('Errore')
                ? 'error--text'
                : 'success--text';
        },
    },

    methods: {
        updateBalance(value) {
            this.$emit('update:starting-balance', Number(value));
        },

        updateDate(value) {
            this.$emit('update:starting-date', value);
            this.menuDate = false;
        },

        updateHistoryDate(value) {
            this.$emit('update:history-date', value);
        },

        updateHistory(value) {
            this.$emit('update:history', value);
        },
    },
};
</script>

<style scoped>
.toolbar-impostazioni {
    display: flex;
    flex-wrap: wrap;
    /* mobile: va a capo senza sovrapporsi */
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
}

.campo-data {
    flex: 1 1 140px;
    /* mobile: si adatta allo spazio disponibile */
    max-width: 160px;
    min-width: 140px;
}

.gruppo-storico {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 1 auto;
}

.check-storico {
    margin: 0;
    padding: 0;
    flex: none;
    white-space: nowrap;
}

.azioni-destra {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
    /* spinge il gruppo a destra */
    min-width: 0;
}

.messaggio {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    /* messaggi lunghi vengono troncati */
    white-space: nowrap;
}

/* Desktop: tutto su una sola riga */
@media (min-width: 960px) {
    .toolbar-impostazioni {
        flex-wrap: nowrap;
    }

    .campo-data {
        flex: 0 0 150px;
    }
}

/* Mobile stretto: campi a metà riga, azioni a tutta larghezza */
@media (max-width: 599px) {
    .campo-data {
        max-width: none;
        flex: 1 1 calc(50% - 8px);
    }

    .gruppo-storico {
        flex: 1 1 100%;
    }

    .azioni-destra {
        flex: 1 1 100%;
        justify-content: flex-end;
    }
}
</style>